import { apiClient } from "../../../services/axiosInstance";
import { Release, ServerListResponse } from "../../../types";

export type PurchaseEntity = {
  entity_type: "ReleaseUserPurchase";
  id: number;
  release_id: number;
  user_id: number;
  create_time: string;
  release: Release;
};

export function getPurchasesList(queryParams: URLSearchParams) {
  return apiClient.get<ServerListResponse<PurchaseEntity>>(
    `/v1/account/digital-purchases${queryParams.size > 0 ? "?" + queryParams : ""}`,
  );
}

export const GET_PURCHASES_LIST_QUERY_KEY = ["purchases-list"];
